import { useCallback } from 'react'
import { toast } from 'sonner'
// 基础请求配置
interface RequestConfig {
  method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'
  data?: any
  params?: Record<string, string | number | boolean>
  headers?: Record<string, string>
}

/**
 * 基础API Hook
 */
export function useBaseApi() {
  const projectId = new URL(window.location.href).searchParams.get('id') || ''

  const request = useCallback(
    async <T = any>(
      endpoint: string,
      config: RequestConfig = {},
    ): Promise<T> => {
      const { method = 'GET', data, params, headers } = config

      const finalEndpoint = `/api/shopping-service-proxy/api/${endpoint}`

      const url = new URL(finalEndpoint, window.location.origin)
      if (params) {
        Object.entries(params).forEach(([key, value]) => {
          if (value !== undefined && value !== null) {
            url.searchParams.append(key, String(value))
          }
        })
      }

      // 准备请求配置
      const requestConfig: RequestInit = {
        method,
        headers: {
          ...headers,
          'x-project-id': projectId,
        },
        credentials: 'include',
      }

      // 添加请求体
      if (data && method !== 'GET') {
        if (data instanceof FormData) {
          // 如果是 FormData，不设置 Content-Type，让浏览器自动设置
          requestConfig.body = data
        } else {
          // 如果是普通数据，设置 JSON Content-Type 并序列化
          requestConfig.headers = {
            'Content-Type': 'application/json',
            ...requestConfig.headers,
          }
          requestConfig.body = JSON.stringify(data)
        }
      }
      // 发送请求
      const response = await fetch(url.toString(), requestConfig)

      // 处理响应
      const contentType = response.headers.get('content-type')
      let result: T

      if (contentType?.includes('application/json')) {
        result = await response.json()
      } else {
        result = (await response.text()) as T
      }

      if (!response.ok) {
        toast.error(`[${(result as any).code}] ${(result as any)?.message}`)
        throw result
      }

      return result
    },
    [projectId],
  )

  return {
    request,
  }
}
